import { atom } from 'jotai';

import type { StoredValidationReport } from './validationReportMatch';

export const validationReportAtom = atom<StoredValidationReport | null>(null);
